import ChatBot from '../components/ChatBot'

export default function MyConsult() {
  return (
    <>
      {/* Header */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="card rounded-4 border-0" style={{ background: 'linear-gradient(135deg, #dc3545 0%, #fd7e14 100%)' }}>
            <div className="card-body p-4 d-flex align-items-center justify-content-between">
              <div>
                <h4 className="text-white mb-1">
                  <i className="bi bi-bug-fill me-2"></i>Infectious Disease AI
                </h4>
                <p className="text-white opacity-75 mb-0 small">
                  Smart Doc Pro AI Assistant — specialist-level guidance on infectious disease management
                </p>
              </div>
              <i className="bi bi-shield-plus-fill text-white opacity-25 d-none d-md-block" style={{ fontSize: '4rem' }}></i>
            </div>
          </div>
        </div>
      </div>

      {/* Chat Area */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="card rounded-4 shadow-sm" style={{ height: 'calc(100vh - 340px)', minHeight: 400 }}>
            <div className="card-body p-0 d-flex flex-column h-100">
              <ChatBot />
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="alert alert-warning rounded-4 d-flex align-items-start gap-3 mb-0">
            <i className="bi bi-exclamation-triangle-fill fs-5 mt-1 flex-shrink-0"></i>
            <div>
              <strong>Medical Disclaimer</strong>
              <p className="mb-0 small mt-1">
                This AI assistant provides general medical information and guidance only. It is not a substitute
                for professional medical advice, diagnosis, or treatment. Always consult a qualified health
                provider. In emergencies, call your local emergency services immediately.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Cards */}
      <div className="row g-3">
        <div className="col-12 col-md-4">
          <div className="card rounded-4 border-0 h-100" style={{ background: '#eef2ff' }}>
            <div className="card-body d-flex align-items-center gap-3">
              <div className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white flex-shrink-0"
                style={{ width: 44, height: 44 }}>
                <i className="bi bi-lightning-fill"></i>
              </div>
              <div>
                <p className="fw-semibold mb-0">Instant Responses</p>
                <p className="text-muted small mb-0">Get quick answers 24/7</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="card rounded-4 border-0 h-100" style={{ background: '#f0fdf4' }}>
            <div className="card-body d-flex align-items-center gap-3">
              <div className="d-flex align-items-center justify-content-center rounded-circle bg-success text-white flex-shrink-0"
                style={{ width: 44, height: 44 }}>
                <i className="bi bi-patch-check-fill"></i>
              </div>
              <div>
                <p className="fw-semibold mb-0">AI-Powered</p>
                <p className="text-muted small mb-0">Advanced medical knowledge</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="card rounded-4 border-0 h-100" style={{ background: '#faf5ff' }}>
            <div className="card-body d-flex align-items-center gap-3">
              <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 text-white"
                style={{ width: 44, height: 44, background: '#6f42c1' }}>
                <i className="bi bi-shield-lock-fill"></i>
              </div>
              <div>
                <p className="fw-semibold mb-0">Confidential</p>
                <p className="text-muted small mb-0">Your privacy matters</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
